import actionTypes from '../constants/action-types';

const setHomePage = (pageId, locale, isMultilingualSite, languageCodes) => ({
  type: actionTypes.SET_HOME_PAGE,
  payload: {
    pageId,
    locale,
    isMultilingualSite,
    languageCodes,
  },
});

export default setHomePage;
